export default "__VITE_ASSET__CIkmpnc7__"